export var SystemEventLevel;
(function (SystemEventLevel) {
    SystemEventLevel["CRITICAL"] = "CRITICAL";
    SystemEventLevel["ERROR"] = "ERROR";
    SystemEventLevel["WARN"] = "WARN";
    SystemEventLevel["INFO"] = "INFO";
    SystemEventLevel["UNKNOWN"] = "UNKNOWN";
    SystemEventLevel["DEBUG"] = "DEBUG";
})(SystemEventLevel || (SystemEventLevel = {}));
var SystemEvent = /** @class */ (function () {
    /**
     * Construct a new SystemEvent. This is a container for data marking a specific
     * event in your app. Ideally the name follows the enum pattern - all uppercase,
     * spaces replaced with underscores i.e. 'FETCH_ERROR'
     */
    function SystemEvent(level, name) {
        this.level = level;
        this.name = name;
    }
    /**
     * Get a string value of this event safe for Splunk.
     */
    SystemEvent.prototype.toString = function () {
        return "SystemEvent(level=".concat(this.level.toString(), " name=").concat(this.name, ")");
    };
    return SystemEvent;
}());
export { SystemEvent };
//# sourceMappingURL=system-event.js.map